import React from 'react';
import { bool, oneOf } from 'prop-types';
import { OwnerType } from '../../types/ownerType';
import { PrivacyType } from '../../types/privacyType';
import TeamBadge from './TeamBadge';
import PrivateBadge from './PrivateBadge';

const Badge = ({ showPrivateLabel = true, ownerType, privacyType }) => {
    const showTeamBadge = ownerType === OwnerType.BUSINESS;
    const showPrivate = privacyType === PrivacyType.PRIVATE && !showTeamBadge;

    return (
        <>
            {showTeamBadge && <TeamBadge />}
            {showPrivate && <PrivateBadge showLabel={showPrivateLabel} />}
        </>
    );
};

Badge.propTypes = {
    showPrivateLabel: bool,
    ownerType: oneOf(Object.values(OwnerType)),
    privacyType: oneOf(Object.values(PrivacyType)),
};

export default Badge;
